import React, { useState, useEffect } from 'react';
import MatrixUserRecord from './MatrixUserRecord';
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

const MultipleMatrixUserRecords = (userData) => {
    const [selected, setSelected] = useState(0);
    const [matrixUsers, setMatrixUsers] = useState([]);

    const handleSelect = (e) => {
        setSelected(e.selected);
    };

    useEffect(() => {
        const activeUsers = []
        const notActiveUsers = []
        userData.data.map(user => {
            if(isActive(user)) {
                activeUsers.push(user)
            } else {
                notActiveUsers.push(user)
            }
        })
        setMatrixUsers(activeUsers.concat(notActiveUsers))
    },[])

    const isActive = (user) => {
        const status = user.find((u) => u.key === 'status')
        return (status && status.value.toLowerCase() === 'active')
    }

    return (
        <> {
            matrixUsers.length > 0 && 
            <TabStrip selected={selected} onSelect={handleSelect}>
                { matrixUsers.map((matrixUser, index) => {
                    const personID = matrixUser.find((user) => user.key === 'personID')?.value
                    let title = personID ? personID.toString() : `Matrix User ${1 + index}`
                    title += isActive(matrixUser) ? ' (Active)' : ''
                    return <TabStripTab title={title} key={index}><MatrixUserRecord key={index} data={matrixUser} /></TabStripTab>
                })}
            </TabStrip>
        } </>
      )
};

export default MultipleMatrixUserRecords